// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"c3532684","580":"9d2bd5e2"}[chunkId] + ".chunk.css";
};